export default __webpack_public_path__ + "static/media/carpenterbee.963ca40f.jpg";